import request from '@/config/axios'

// 标签
export const getScenicTagPage = (params: any) => {
  return request.get({ url: '/scenic/tag/page', params })
}

export const getScenicTagListAll = () => {
  return request.get({ url: '/scenic/tag/list-all' })
}

export const getScenicTag = (id: number) => {
  return request.get({ url: '/scenic/tag/get', params: { id } })
}

export const createScenicTag = (data: any) => {
  return request.post({ url: '/scenic/tag/create', data })
}

export const updateScenicTag = (data: any) => {
  return request.put({ url: '/scenic/tag/update', data })
}

export const deleteScenicTag = (id: number) => {
  return request.delete({ url: '/scenic/tag/delete', params: { id } })
}

export const deleteScenicTagList = (ids: number[]) => {
  return request.delete({ url: '/scenic/tag/delete-list', params: { ids: ids.join(',') } })
}
